import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line

import AgencyLandingPage from "demos/AgencyLandingPage.js";
import PricingPage from "pages/Pricing.js";
import AboutUsPage from "pages/AboutUs.js";
import ContactUsPage from "pages/ContactUs.js";
import BlogIndexPage from "pages/BlogIndex.js";
import TermsOfServicePage from "pages/TermsOfService.js";
import PrivacyPolicyPage from "pages/PrivacyPolicy.js";
import Worker from "pages/Worker";
import ComponentRenderer from "ComponentRenderer.js";
import MainLandingPage from "MainLandingPage.js";
import ThankYouPage from "ThankYouPage.js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RestaurantLandingPage from "pages/VizualTv";
import PrintPage from "pages/PrintPage";
import SaaSProductLandingPage from "demos/SaaSProductLandingPage";
import EventLandingPage from "demos/EventLandingPage";
export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AgencyLandingPage />} />

        <Route path="/aboutus" element={<AboutUsPage />} />

        <Route path="/latest" element={<BlogIndexPage />} />

        <Route path="/contact-us" element={<ContactUsPage />} />

        <Route path="/whatwedo" element={<PricingPage />} />

        <Route path="/design-ads" element={<Worker />} />

        <Route path="/promotions" element={<RestaurantLandingPage />} />

        <Route path="/print-ads" element={<PrintPage />} />

        <Route path="/terms" element={<EventLandingPage />} />
      </Routes>
    </Router>

  );
}

